import CloneUtils from '../../../../utils/cloneUtils';
import { MasterDescriptorsMapType, MasterDescriptorType } from '../types';

export function getMasterDescriptorsMap(
    initialDescriptors: MasterDescriptorType[],
    horizontalLevel = 0
): MasterDescriptorsMapType {
    const descriptors: MasterDescriptorType[] = CloneUtils.deepClone(initialDescriptors);
    let result: MasterDescriptorsMapType = {};

    for (const descriptor of descriptors) {
        result[descriptor.id] = { ...descriptor, horizontalLevel: horizontalLevel };
        if (descriptor.subFields.length) {
            result = { ...result, ...getMasterDescriptorsMap(descriptor.subFields, horizontalLevel + 1) };
        }
    }

    return result;
}
